<div class="container bg-white">
  <div class="row ">
    <div class="col">
      <div class="row logoheader" *ngIf="url === '/support'">
        <div class="col-12 pt-2 pb-1 cursor outline-0 mt-0 mb-3">
          <div class="row">
            <div class="col-1">
              <div class="cursor mt-1" style="font-size: 1.3em;" [routerLink]="['/home']">
                <i class="fas fa-chevron-circle-left font-size-16 text-white"></i>
              </div>
            </div>
            <div class="col text-center" [routerLink]="['/home']">
              <img src="./assets/images/OlarmewithMerchantMate.png" class="logo-background" />
            </div>
            <div class="col-2">
              <div class="cursor float-right" style="font-size: 1.3em;position: absolute;right: 35%;">
                <div>
                  <i class="fas fa-user cursor text-white" (click)="onSignInClick()"></i>
                </div>
              </div>
              <div class="search-label" style="position: absolute;right: 3%;top:89%">
                <span class="font-weight-bold-500 text-white">{{ecomservice.htmlUtil.textTruncate(username,10)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row logoheader" *ngIf="url == '/home'">
        <div class="col-12 pt-2 pb-1 cursor outline-0 mt-0 mb-3">
          <div>
            <img src="./assets/images/OlarmewithMerchantMate.png" class="logo-background" />
          </div>
          <div class="cursor float-right" style="font-size: 1.3em;margin-top: -31px;position: absolute;right: 6%;">
            <div>
              <i class="fas fa-user cursor text-white" (click)="onSignInClick()"></i>
            </div>
          </div>
          <div class="search-label" style="position: absolute;right: 3%;top:89%">
            <span class="font-weight-bold-500 text-white">{{ecomservice.htmlUtil.textTruncate(username,10)}}</span>
          </div>
          <div class="cursor" style="font-size: 1.3em;margin-top: -31px;position: absolute;" (click)="overlayOpen()">
            <i class="fa icons icon-bar text-white" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div id="navbar" class="row" style="margin-top: -17px" *ngIf="url == '/home'">
        <div class="col text-center navbar-col" (click)="pickMyLocation()">
          <label class="mb-1 pt-1 background-white one-line p-1 border-radius-4 font-weight-normal" style="display: inline-flex;color: #9c9c9c;
    padding: 7px !important;">
            <i class="font-size-11 icons icon-map pl-2 pr-1 text-danger" style="padding-top: 3px"></i>
            <small class="font-size-14">
              {{userhomeAddress}}
            </small>
            <i class="ml-1 font-size-11 fas fa-chevron-down icon-color-grey pr-2"
              style="padding-top: 2px;color: #9c9c9c"></i>
          </label>
        </div>
        <div class="col-3 text-center sticky-show">
          <button class="btn cart-btn-paylater outline-0 line-height-1 box-shadow-none float-right "
            (click)="onFavoriteClick('ALL')" style="width: 100%" type="button"> All</button>
        </div>
      </div>
      <div class="row logoheader" style="padding: 5px" [ngClass]="{'display-none' : (url !== '/stores')}">
        <div class="col-12 pl-0 pr-0 p-2">
          <div class="input-group border-0 border-radius-4 store-location ml-1">
            <div class="input-group-prepend outline-0 ">
              <div class="cursor mt-1" *ngIf="url == '/stores'" [routerLink]="['/home']">
                <i class="fas fa-chevron-circle-left fa-2x text-white"></i>
              </div>
            </div>
            <!-- <button class="btn btn-secondary-outline pt-0 outline-0 box-shadow-none pl-1 pr-0">
              <i class="icons icon-map pl-2 text-danger cursor" (click)="onClickSeachIcon()"></i>
            </button> -->
            <ng-select [searchFn]="customSearchFn" (clear)="onClearAddressClick()"
              style="margin: -5px 0px 0px 3px !important;color: #e7e8e8"
              class="storeplace no-border-ng-select form-control border-0 font-size-11 font-weight-bold-500 pl-1 outline-0 box-shadow-none background-none"
              (keyup)="placesKeyUp($event)" (change)="onLocationChange($event,'');" [(ngModel)]="currentLocation"
              [items]="googlePlacesResults" bindLabel="description" [clearable]="false" bindValue="place_id"
              placeholder="Enter your street address" [searchable]="true" type="text" componentFrom="search">

              <ng-template ng-label-tmp let-item="item">
                <i class="fas fa-map-marker-alt text-danger mr-1"></i>
                <span class="text-white">
                  {{item.description}}
                </span>
              </ng-template>

              <ng-template ng-header-tmp *ngIf="googlePlacesResults.length > 0">
                <div class="row">
                  <div class="col">
                    <label class="mt-2 text-dark" for="">Please select your address for today :</label>
                  </div>
                </div>
              </ng-template>

              <ng-template *ngIf="googlePlacesResults.length > 0 && this.cookie.cookie_user_location" ng-footer-tmp
                class="border p-2 mb-1 background-grey border border-radius-4">
                <br>
                <input (keyup)="textboxKeyup($event);$event.stopImmediatePropagation();" type="text"
                  class="form-control border-0" placeholder="Enter new street address" />
                <br>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div>
                  {{item.description}}
                </div>
              </ng-template>
            </ng-select>

            <!-- <ng-select [searchFn]="customSearchFn" (clear)="onClearAddressClick()"
              style="margin: -6px 0px 2px -10px !important;color: #e7e8e8"
              class="storeplace no-border-ng-select form-control border-0 font-size-11 font-weight-bold-500 pl-1 outline-0 box-shadow-none background-none"
              [(ngModel)]="currentLocation" (keyup)="placesKeyUp($event)" [items]="googlePlacesResults"
              bindLabel="description" [clearable]="true" bindValue="place_id" placeholder="Search Nearest Location"
              [searchable]="true" type="text" componentFrom="search" (change)="onLocationChange($event)">
            </ng-select> -->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div id="resultWindow"></div>
        </div>
      </div>
    </div>

    <div *ngIf="url == '/home'" class="col-12 pt-3 pl-0 pr-0 pb-1 mb-0">
      <div class="scrolling-wrapper pb-0" style="width: 100% !important;">
        <carousel [showIndicators]="false">
          <div *ngFor="let promo of olarmePromoList;let i=index">
            <slide *ngIf="promo">
              <img [defaultImage]="defaultImage" [lazyLoad]="promo" [src]="promo" alt="olarme promo"
                style="display: block; width: 100%;">
            </slide>
          </div>
        </carousel>
        <!-- <div class="card mr-3  border-0" *ngFor="let promo of olarmePromoList;let i=index">
          <div id="cardimage" style="border-radius: 4px">
            <img [defaultImage]="defaultImage" [lazyLoad]="promo" alt="olarme promo" class=""
              style="display: block; width: 50%;min-height:50% !important;">
          </div>
        </div> -->
      </div>
    </div>

    <div *ngIf="url == '/home'" class="col-12 py-1">
      <div class="row mb-1 no-gutters">
        <!-- <div class="col text-center m-1">
          <div class="cursor" (click)="onFavoriteClick('COLLECTION')">
            <img src="./assets/images/homeicons/pickup.png" alt="olarme promo" class="img-fluid ml-3"
              style="display: block; width: 70%;">
          </div>
          <span class="font-weight-bold-500">Pickup</span>
        </div> -->
        <div class="col-3 text-center ">
          <div class="cursor" (click)="onFavoriteClick('LOCAL')">
            <img src="./assets/images/homeicons/local.png" alt="olarme promo" class="img-fluid cusine-img">
            <div class="search-label"><small class="font-weight-bold-500">Local</small></div>
          </div>
        </div>
        <div class="col-3 text-center ">
          <div class="cursor" (click)="onFavoriteClick('CHINESE')">
            <img src="./assets/images/homeicons/chinese.png" alt="olarme promo" class="img-fluid cusine-img">

            <div class="search-label"><small class="font-weight-bold-500">Chinese</small></div>
          </div>
        </div>
        <div class="col-3 text-center ">
          <div class="cursor" (click)="onFavoriteClick('INDIAN')">
            <img src="./assets/images/homeicons/indian.png" alt="olarme promo" class="img-fluid cusine-img">

            <div class="search-label"><small class="font-weight-bold-500">Indian</small></div>
          </div>
        </div>
        <div class="col-3 text-center">
          <div class="cursor" (click)="onFavoriteClick('ALL')">
            <img src="./assets/images/homeicons/all.png" alt="olarme promo" class="img-fluid  cusine-img">

            <div class="search-label"><small class="font-weight-bold-500">All</small></div>
          </div>
        </div>

      </div>
      <div class="row mt-1 no-gutters">
        <!-- <div class="col text-center m-1">
          <div class="cursor" (click)="onFavoriteClick('HALAL')">
            <img src="./assets/images/homeicons/fastfood.png" alt="olarme promo" class="img-fluid ml-3"
              style="display: block; width: 80%;">
          </div>
          <span class="font-weight-bold-500">FastFood</span>
        </div> -->
        <div class="col-3 text-center ">
          <div class="cursor" (click)="onFavoriteClick('VEGETARIAN')">
            <img src="./assets/images/homeicons/vegetarian.png" alt="olarme promo" class="img-fluid cusine-img">

            <div class="search-label"><small class="font-weight-bold-500">Vegetarian</small></div>
          </div>
        </div>
        <div class="col-3 text-center">
          <div class="cursor" (click)="onFavoriteClick('BAKERY')">
            <img src="./assets/images/homeicons/bakery.png" alt="olarme promo" class="img-fluid cusine-img">

            <div class="search-label"><small class="font-weight-bold-500">Bakery</small></div>
          </div>
        </div>
        <div class="col-3 text-center ">
          <div class="cursor" (click)="onFavoriteClick('PIZZA')">
            <img src="./assets/images/homeicons/pizza.png" alt="olarme promo" class="img-fluid cusine-img">
            <div class="search-label"><small class="font-weight-bold-500">Pizza</small></div>
          </div>
        </div>
        <div class="col-3 text-center ">
          <div class="cursor" (click)="onMoreClick()">
            <img src="./assets/images/homeicons/more.png" alt="olarme promo" class="img-fluid cusine-img">
            <div class="search-label"><small class="font-weight-bold-500">More</small></div>
          </div>
        </div>
      </div>
      <!-- <div class="row my-1 no-gutters"> -->
      <!-- <div class="col text-center m-1">
          <div>
            <img src="./assets/images/homeicons/fishchips.png" alt="olarme promo" class="img-fluid ml-3"
              style="display: block; width: 60%;">
          </div>
          <span class="font-weight-bold-500">Fish & Chips</span>
        </div> -->


      <!-- <div class="col text-center m-1">
          <div>
            <img src="./assets/images/homeicons/bakery.png" alt="olarme promo" class="img-fluid ml-3"
              style="display: block; width: 60%;">
          </div>
          <span class="font-weight-bold-500">Bakery</span>
        </div> -->

      <!-- </div> -->
    </div>

    <div *ngIf="url == '/home'" class="col py-1 mt-2">
      <div *ngIf="merchantPromoList.length > 0">
        <label class="font-weight-bold-500 font-size-16 text-dark">
          <img class="img-icons" src="assets/images/homeicons/GreatFoodDiscounts.png" alt="">
          Great Food & Discounts
        </label>
      </div>
      <!--<carousel [interval]="2000" [itemsPerSlide]="itemsPerSlide"
              [singleSlideOffset]="singleSlideOffset"
              [noWrap]="!noWrap" [indicatorsByChunk]="true"
              [startFromIndex]="0" [isAnimated]="true">
      <div *ngFor="let promo of merchantPromoList;let i=index">
        <slide>
          <div *ngIf="promo.promo1 && promo.display" style="border: 1px solid black !important; border-radius: 1px !important; background:purple; width: 50% !important; position: absolute; top: 10%;">
            <span class="text-white p-4 font-weight-bold-500 font-size-16">{{promo.promo1}}</span>
          </div>
          <div *ngIf="promo.promo2 && promo.display" style="border: 1px solid black !important; border-radius: 1px !important; background: purple; width: 50% !important; position: absolute; top: 22%;">
            <span class="text-white p-4 font-weight-bold-500 font-size-16">{{promo.promo2}}</span>
          </div>
          <img *ngIf="promo.display" [src]="promo.imagepath" alt="olarme promo" class="img-fluid" style="display: block; width: 100%;">
          <div *ngIf="promo.display" class="carousel-caption d-none d-md-block">
            <h3 class="text-dark">{{promo.promo1}}</h3>
            <p class="text-dark">{{promo.promo2}}</p>
          </div>
        </slide>
      </div>
    </carousel>-->
      <!--<div id="promodiv1">
      <div class="promodiv2" *ngFor="let promo of merchantPromoList;let i=index" style="display:inline-block;">
        <img src="http://placehold.it/300x150" />
      </div>
    </div>-->
      <div class="scrolling-wrapper mb-2">
        <div class="card mr-2" *ngFor="let promo of merchantPromoList;let i=index">
          <div id="cardimage" class="cardimageloc cursor-pointer" (click)="onLocationClickheader(promo)"
            [ngClass]="{'blink':promo.blink}">
            <div *ngIf="promo.oocls_slider_promotional_message"
              style="border: 1px solid black !important; border-radius: 1px !important; background:purple; position: absolute; top: 10%;">
              <span
                class="text-white p-2 font-weight-bold-500 font-size-16">{{ecomservice.htmlUtil.textTruncate(promo.oocls_slider_promotional_message,25)}}</span>
            </div>
            <div *ngIf="promo.oocls_slider_promotional_message1"
              style="border: 1px solid black !important; border-radius:1px !important; background: purple; position: absolute; top: 40%;">
              <span
                class="text-white p-2 font-weight-bold-500 font-size-16">{{ecomservice.htmlUtil.textTruncate(promo.oocls_slider_promotional_message1,25)}}</span>
            </div>
            <img *ngIf="promo.display_promotion" [defaultImage]="defaultImage"
              [lazyLoad]="promo.oocls_banner_image_name" alt="olarme promo" class=""
              style="display: block; width: 50%;min-height:50% !important;">

          </div>
          <div class="row mt-2 no-gutters cardimageloc">
            <div class="col-8">
              <span
                class="text-wrap pl-2 font-weight-bold-500 font-size-14 text-capitalize">{{ecomservice.htmlUtil.textTruncate(promo.oocls_company_name,20)}}</span>
              <div class="font-size-14 pl-2 mb-1 font-weight-bold-500 text-capitalize">
                <span class="text-muted">{{ecomservice.htmlUtil.textTruncate(promo.oocls_location_name,20)}}</span>
              </div>
            </div>
            <div class="col-4">
              <div class="font-size-11 mb-1 pr-2 text-right">
                <span class="">
                  <i class="fas fa-map-marker icon-color-grey pr-1 "></i>
                  {{promo.location_distance}}
                  <!--<img src="assets/images/google-maps.png" class="icon-google-maps">-->
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- <div class="container" [ngClass]="{'display-none' : (url !== '/stores'), 'display-block' : (url == '/stores') }">
    <div class="row mt-2 pt-2">
      <div class="col-12 mt-2 mb-0">
        <label class="mb-0 font-size-90"><span>Select location for search</span></label>
      </div>
    </div>
  </div> -->
    <div class="container background-grey" style="margin-top: -16px;margin-bottom: 15px;">
      <!-- <div class="row" style="margin-top: -5% !important;"
        [ngClass]="{'display-none' : (url !== '/stores'), 'display-block' : (url == '/stores') }">
        <div class="col ">
          <div class="input-group bg-white mb-2 border-0 border-radius-4">
            <div class="input-group-prepend outline-0 ">
              <button class="btn btn-secondary-outline pt-0 outline-0 box-shadow-none">
                <i class="fas fa-map-marker fa-sm pr-1"></i>
              </button>
            </div>
            <input type="text" [(ngModel)]="currentLocation"
              class="form-control border-0 font-size-11 font-weight-bold-500 pl-1 py-4 outline-0 box-shadow-none"
              (keydown.enter)="$event.preventDefault()" placeholder="Search Nearest Location" autocorrect="off"
              autocapitalize="off" spellcheck="off" type="text" #search />
          </div>
        </div>
      </div> -->

      <div id="navbar-stores" class="row mt-3 search-box" *ngIf="url === '/stores'">
        <div class="col mx-3 input-search">
          <div class="input-group mb-2 border-radius-4 ">
            <div class="input-group-prepend">
              <button class="border-0 rounded-0 rounded form-control pt-2" style="height: 100%">
                <i class="fas fa-search fa-sm text-orange"></i>
              </button>
            </div>
            <input type="text" [(ngModel)]="venue"
              class="form-control form-control-sm border-0 rounded-0 p-1 input-search" aria-label="Search"
              placeholder="Search Restaurant, Cuisines or Dishes" (keyup)="onKey($event)">
            <div class="input-group-append ml-2 align-items-center bg-white">
              <!-- <span class="cursor" style="color: blue;" (click)="onClearClick()">Clear All</span> -->
              <button class="btn rounded-0 pt-0 box-shadow-none form-control form-control-sm border-0 "
                (click)="onFilterClick()">
                <i class="icons icon-filter" [ngClass]="{'icon-blue':filtersSelectedCount > 0}"></i>
                <span class="badge badge-filter rounded-pill bg-warning text-dark"
                  *ngIf="filtersSelectedCount > 0">{{filtersSelectedCount}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row pb-2" *ngIf="url == '/stores'">
      <div class="col-6 pr-1">
        <ng-select class="cusineDietaryListWidth cusineimg" [items]=cusineList bindLabel="dc_name" bindValue="dc_guid"
          placeholder="Cuisine Priorities" [(ngModel)]="cusineSelected" type="cusine" componentFrom="search"
          [searchable]="false" (change)="onCusineChange($event)" (clear)="clear('CUSINE')" [multiple]="false">
          <ng-template ng-label-tmp let-item="item">
            <img width="20%" [defaultImage]="defaultImage" [lazyLoad]="item.imgsource" />
            <span class="pl-4"><b>{{item.dc_name}}</b></span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <img width="40%" [defaultImage]="defaultImage" [lazyLoad]="item.imgsource" />
            <span class="pl-4"><b>{{item.dc_name}}</b></span>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-6 pl-0">
        <ng-select class="cusineDietaryListWidth dietaryimg" [items]=dietaryoptions bindLabel="dc_name"
          bindValue="dc_guid" placeholder="Dietary Options" [(ngModel)]="optionSelected" type="option"
          componentFrom="search" [searchable]="false" (change)="onOptionsChange($event)" (clear)="clear('OPTION')">
        </ng-select>
      </div>
    </div> -->
    </div>
    <!--<div class="row mt-2 mb-0 ml-0" *ngIf="url == '/home'">-->
    <div class="col mt-2 mb-0 ml-0" *ngIf="url == '/home'">
      <div class="row">
        <div class="col">
          <label for="" class="font-weight-bold-500 text-dark m-0 mt-0 mb-1 font-size-16">
            <img class="img-icons" src="assets/images/homeicons/Suggestionsnearyou.png" alt="">
            Suggestions near
            you
          </label>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col">
          <marquee direction="left">
            <ul id="discounts">
              <li>Get 10% discount on your first order</li>
              <li>Get 5% discount on every 5<sup>th</sup> order</li>
              <li>Get 5% discount on order net-total above 200</li>
            </ul>
          </marquee>
        </div>
      </div> -->
      <!--</div>-->
    </div>
    <ng-template #userlocation>
      <div class="modal-body rounded bg-white pb-0">
        <div class="row cursor">
          <div class="col p-2 border-bottom text-center">
            <small class="">Your location has been changed do you want to update?</small>
          </div>
        </div>
        <div class="row">
          <div class="col cursor p-2 text-center border-right" (click)="onPermissionClick('N')">
            <label for="" class="font-color-dark-blue font-weight-bold">Don't Allow</label>
          </div>
          <div class="col cursor p-2 text-center" (click)="onPermissionClick('Y')">
            <label for="" class="font-color-dark-blue font-weight-bold">Allow</label>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="overlay" *ngIf="overlayDisplay">

      <!-- <div class="row margin-top-8">
        <div class="col-12 pr-4">
          <button class="float-right border-0 color-white background-none outline-0 box-shadow-none font-size-16"
            (click)="closeOverlay()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="col-12 mt-6 headings p-0">
        <div class="row p-2">
          <div class="faicon col-2"><i class="fa fa-user-circle" aria-hidden="true"></i></div>
          <div class="col cursor-pointer" (click)="onSignInClick()" *ngIf="!loggedIn">Login In / Sign Up</div>
          <div class="col cursor-pointer" (click)="onSignInClick()" *ngIf="loggedIn">Welcome {{username}}</div>
        </div>
        <hr class="color-white px-2">
        <div class="row p-2">
          <div class="faicon col-2"><i class="fa fa-phone" aria-hidden="true"></i></div>
          <div class="col cursor-pointer" (click)="suppotCenter()">Support</div>
        </div>
        <hr class="color-white px-2">
      </div>
      <div class="row" style="margin-top: 80%;">
        <div class="col-12 text-center">
          <button class="background-none outline-0 box-shadow-none listyourrestaurantbtn border-radius-4"
            (click)="listYourRestaurantClick()">
            List Your Restaurant
          </button>
        </div>
      </div>
      <div class="row" style="margin-top: 20%;">
        <div class="col-12 text-center">
          <button class="background-none outline-0 box-shadow-none merchantpotal border-radius-4"
            (click)="merchantportalClick()">
            Merchant Portal
          </button>
        </div>
      </div> -->
      <app-ecom-contact-us (submitted)="contactUsEventEmitter($event)"></app-ecom-contact-us>

    </div>

    <app-loading-component></app-loading-component>
    <ng-template #userlocationpopup>
      <div class="modal-body rounded p-0" [ngStyle]="{'background-color': this.colors[this.random]}">
        <div class="container">
          <!--<div class="row mt-0 pt-0 banner-image">-->
          <!--<h6 class="text-center pl-2" style="padding: 65px; margin-left: 5%"></h6>-->
          <!--</div> -->

          <div class="row ">
            <div class="col">
              <img src="./assets/images/location/locationTop.png" class="location-popup-image" />
            </div>
          </div>
          <!-- <div class="row mt-3">
            <div class="col text-center">
              <p class="mb-0 font-weight-bold-500 text-white ">Enter your street address</p>
            </div>
          </div> -->
          <div class="mt-3 pb-1 pt-0 border border-radius-4 model-location-content bg-white">
            <div class="row">
              <div class="col">
                <div class="input-group mb-0" style="border-radius: 10px !important;">
                  <div class="input-group-prepend outline-0 pt-1" style="margin-top: -4px">
                    <button class="btn  pt-0 px-0 outline-0 box-shadow-none border-0">
                      <i class="icons icon-map pl-2 pr-1 text-danger fa-sm pr-1"></i>
                    </button>
                  </div>
                  <!-- <input type="search" aria-label="Input your location or landmark" aria-describedby="button-addon2"
                    autocapitalize="off" spellcheck="off" [(ngModel)]="currentLocation"
                    class="form-control font-size-14 font-weight-bold-500 pl-1 py-2 outline-0 box-shadow-none pac-target-input border-0"
                    ngx-google-places-autocomplete [options]='options' #placesRef="ngx-places"
                    (onAddressChange)="handleAddressChange($event)" /> -->
                  <ng-select [searchFn]="customSearchFn" (clear)="onClearAddressClick()"
                    (change)="onLocationChange($event,'home');" style="margin: -1px -15px 2px -10px !important"
                    (keyup)="placesKeyUp($event)"
                    class="custom no-border-ng-select form-control border-0 font-size-11 font-weight-bold-500 pl-1 outline-0 box-shadow-none background-none"
                    [(ngModel)]="currentLocation" [items]="googlePlacesResults" bindLabel="description"
                    [clearable]="false" bindValue="place_id" placeholder="Enter your street address" [searchable]="true"
                    type="text" componentFrom="search">
                    <ng-template ng-header-tmp *ngIf="googlePlacesResults.length > 0">
                      <div class="row">
                        <div class="col">
                          <label class="mt-2 text-dark" for="">Please select your address for today :</label>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template *ngIf="googlePlacesResults.length > 0 && this.cookie.cookie_user_location"
                      ng-footer-tmp class="border p-2 mb-1 background-grey border border-radius-4">
                      <br>
                      <input (keyup)="textboxKeyup($event);$event.stopImmediatePropagation();" type="text"
                        class="form-control border-0" placeholder="Enter new street address" />
                      <br>
                    </ng-template>
                    <ng-template ng-optionS-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div>
                        {{item.description}}
                      </div>
                    </ng-template>
                  </ng-select>


                  <div class="input-group-prepend bg-white outline-0 mt-1 search pr-1" style="padding-top: 2.5px;">
                    <button type="button" (click)="onFindFoodClick()"
                      class="btn-circle-home-popup dropdown-toggle text-white border-0 outline-0 box-shadow-none mt-0 p-0 px-1">
                      <i class="fas fa-search text-white"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="text-danger" *ngIf="locationSearchError">
                  Input your location or landmark to explore
                </span>
              </div>
            </div>
          </div>

          <div class="row my-4">
            <div class="col">
              <img src="./assets/images/location/locationBottom.png" class="location-popup-image-bottom" />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <br>
              <br>
              <br>
              <br>
              <!--               
              <label for="" class="text-danger">We have released updates and bug fixes to our app, please update your location and login to reflect the new changes</label>
               -->
              <br>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <div id="map" class="map"></div>